export enum OrganizationEnum {
  ORG1 = 'ORG1',
  ORG2 = 'ORG2',
}

export const OrganizationMapping = {
  [OrganizationEnum.ORG1]: {
    key: OrganizationEnum.ORG1,
    name: 'Unidade 1',
    url: 'Unidade1',
  },
  [OrganizationEnum.ORG2]: {
    key: OrganizationEnum.ORG2,
    name: 'Unidade 2',
    url: 'Unidade2',
  },
};
